module.exports = __webpack_public_path__ + "img/about-辅导项目-中级职称（中医）类.e4d6beb5.jpg";